import { Box, Card, CardContent, Typography } from '@mui/material';

function Placeholder({ title, note }: { title: string; note: string }) {
  return (
    <Box>
      <Card>
        <CardContent sx={{ py: 6, textAlign: 'center' }}>
          <Typography variant="h3" sx={{ mb: 1 }}>
            {title}
          </Typography>
          <Typography color="text.secondary">{note}</Typography>
        </CardContent>
      </Card>
    </Box>
  );
}

export const InvoicesPage = () => (
  <Placeholder
    title="Invoices"
    note="Invoice listing and PDF download — Phase 3b, after backend invoice service lands in Phase 2."
  />
);

export const UsersPage = () => (
  <Placeholder
    title="Users"
    note="User management — add staff, assign roles. Backend /auth/register endpoint is ready."
  />
);

export const NotFoundPage = () => (
  <Placeholder title="404" note="Page not found." />
);
